export default __webpack_public_path__ + "static/media/fur.750d2414.png";